G.FxMapLayer = function(){
	G.PoolGroup.call(this,G.FxMapPart);
	this.fixedToCamera = true;

	G.sb("fxMap").add(this.init,this);
};

G.FxMapLayer.prototype = Object.create(G.PoolGroup.prototype);


G.FxMapPart = function() {
	
	G.Image.call(this);
	this.state = game.state.getCurrentState();

};

G.FxMapPart.prototype = Object.create(G.Image.prototype);

G.FxMapPart.prototype.emptyUpdate = function(){};

G.FxMapPart.prototype.reset = function(obj){
 
	this.x = obj.position ? obj.position.x : obj.x;
	this.y = obj.position ? obj.position.y : obj.y;

	this.anchor.setTo(0.5);
	this.scale.setTo(1);
	this.alpha = 1;
	this.angle = 0;
	this.blendMode = 0;
	this.changeTexture(null);
	this.visible = true;
	this.update = this.emptyUpdate;
	this.revive();

};

G.FxMapPart.prototype.init = function(effect,obj){

	this.reset(obj);

	if (this[effect]) {
		this[effect].apply(this,arguments);
	}else {
		console.warn('There is no ' + effect + ' in G.FxPart');
	}
	
};

G.FxMapPart.prototype.star = function(fx,obj) {

	this.changeTexture('starPart');

	this.blendMode = 1;

	this.alpha = obj.alpha || 1;

	this.grav =  typeof obj.grav === 'undefined' ? 0 : obj.grav;
	this.timer = obj.timer || game.rnd.between(20,40);
	this.blendMode = 0;
	this.scale.setTo(obj.scale || 0.7);
	this.velX =  obj.velX || game.rnd.realInRange(-10,10);
	this.velY = obj.velY || game.rnd.realInRange(-20,-8);
	this.velAngle = game.rnd.realInRange(-5,5);
	this.angle = game.rnd.realInRange(0,360);

	this.update = this.starUpdate;

};

G.FxMapPart.prototype.starUpdate = function(){

	this.x += this.velX;
	this.y += this.velY;

	this.velX *= 0.95;
	this.velY *= 0.95;

	this.angle += this.velAngle;

	if (this.timer-- < 0) {
		this.alpha -= 0.05;
		if (this.alpha <= 0) {
			this.kill();
		}
	}

};